module.exports = __webpack_public_path__ + "static/media/arrowLeft.04814637.svg";